<template>
	<v-dialog
		v-model="localShowDialog"
		:width="$vuetify.display.mobile ? '95%' : '500px'"
		:persistent="waitingForSeverResponse"
		@click:outside="handleDismiss"
		@keydown.esc="handleDismiss"
	>
		<v-card data-test="delete-core-dialog">
			<v-card-title class="dialog-header sgnl-subtitle-medium">
				Delete "{{ deleteCoreData.Name }}"?
			</v-card-title>
			<v-divider />
			<v-card-text class="dialog-body">
				<p>Would you like to delete the core "{{ deleteCoreData.Name }}"?</p>
				<v-alert
					:icon="false"
					class="sgnl-paragraph-s-regular"
					type="warning"
					variant="outlined"
					elevation="0"
				>
					<strong>This operation can not be undone.</strong>
				</v-alert>
				<v-alert
					v-if="showError"
					:icon="false"
					border="start"
					class="sgnl-paragraph-s-regular"
					type="warning"
					variant="outlined"
					elevation="0"
				>
					{{ errorMessage }}
				</v-alert>
			</v-card-text>
			<v-divider />
			<v-card-actions class="dialog-footer">
				<v-btn
					variant="outlined"
					@click="handleDismiss"
					data-test="cancel-button"
				>
					Cancel
				</v-btn>
				<v-btn
					variant="flat"
					color="error"
					:loading="waitingForSeverResponse"
					@click="commitDeleteCore"
					data-test="delete-button"
				>
					Delete
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import { sdk } from "@/js/sdk";
import { SdkError } from "@signaloid/cloud-compute-engine-client";
import axios from "axios";
import { useCoresStore } from "@/stores/cores";
import { monitoringCaptureError } from "@/plugins/monitoring";

export default defineComponent({
	name: "DeleteCoreDialog",
	emits: ["update:showDialog", "core-deleted", "close-dialog"],
	props: { showDialog: Boolean, deleteCoreData: Object },
	data: () => ({
		waitingForSeverResponse: false,
		errorMessage: "unknown error",
		showError: false,
	}),
	setup() {
		const coresStore = useCoresStore();
		return { coresStore };
	},
	computed: {
		localShowDialog: {
			get() {
				return this.showDialog;
			},
			set(value) {
				this.$emit("update:showDialog", value);
			},
		},
		isLocalCore() {
			return !this.deleteCoreData.CoreID.includes("cor_");
		},
	},
	methods: {
		async commitDeleteCore() {
			this.errorMessage = undefined;
			this.showError = false;
			try {
				this.waitingForSeverResponse = true;
				if (this.isLocalCore) {
					this.coresStore.removeCoreFromLocalCoresList(this.deleteCoreData);
					this.$emit("core-deleted", this.deleteCoreData);
					this.closeDialog();
				} else {
					await sdk.cores.delete(this.deleteCoreData.CoreID);

					this.$emit("core-deleted", this.deleteCoreData);
					this.closeDialog();
				}
			} catch (error) {
				monitoringCaptureError(error, "Delete core");
				if (error instanceof SdkError) {
					this.errorMessage = "An error occurred while deleting the core.";
				} else if (axios.isAxiosError(error)) {
					this.errorMessage = "Failed to delete the core. Make sure you have an active internet connection.";
				} else {
					this.errorMessage = "An error occurred while deleting the core.";
				}
				this.showError = true;
			} finally {
				this.waitingForSeverResponse = false;
			}
		},
		handleDismiss() {
			if (this.waitingForSeverResponse) {
				return;
			}
			this.closeDialog();
		},
		closeDialog() {
			this.$emit("close-dialog");
		},
	},
});
</script>
